import styled from 'styled-components';
import { layout } from 'Constants';
import { colors } from 'Constants';
import Container from './Container';
import React from 'react'
import HeaderBackground from './images/header_bg@2x.png'

const TitleHeader = styled.span`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 48px;
  line-height: 60px;
  text-align: left;
  color: #1a3673;
`;



const TitleHeader2 = styled.div`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
  text-align: ${props => props.align || 'left'};
  color: #1a3673;
`;


export default styled.h2`
color:#012169;// ${colors.textAccent};
font-size: 1.3em;
font-weight:bold;
>p {
    color:red;
}
`;

const SubHeader = styled.div`
color:#081f65;// ${colors.textAccent};
font-weight:bold;
font-family:Arial, Helvetica, sans-serif ;
`;

const Text = styled.div`
  font-family: Elevance Sans Regular;
 
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #131331;
 
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width:100%;

}
`;

const HeaderV2Container = styled.div`
 
  min-height: 209px;
  background: #e1edff;
  display:flex ;
  flex-direction  :column ;
  justify-content:center ;
  padding-left:120px ;
  padding-right:120px ;
 // background-image:url(${HeaderBackground}) ;
  background-repeat:no-repeat ;
  background-position:right ;
  background-size:340px 180px;
  padding-bottom:20px ;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
  padding: 10px;

}

  

`;

const HeaderV2 = ({ title, text }) => {
  return (
    <HeaderV2Container>
      <TitleHeader>{title}</TitleHeader>
      <Text>{text}</Text>
    </HeaderV2Container>
  );
};

export { SubHeader, TitleHeader,HeaderV2,TitleHeader2 };
